var map = {
	"./002-corn.png": [
		38,
		3
	],
	"./005-farm.png": [
		39,
		4
	],
	"./006-farmer.png": [
		40,
		5
	],
	"./007-farmer-girl.png": [
		41,
		6
	],
	"./009-pig.png": [
		42,
		7
	],
	"./010-cow.png": [
		43,
		8
	],
	"./011-carrots.png": [
		44,
		9
	],
	"./013-chicken.png": [
		45,
		10
	],
	"./016-sheep.png": [
		46,
		11
	],
	"./018-horse.png": [
		47,
		12
	],
	"./023-eggs.png": [
		11
	],
	"./026-goose.png": [
		48,
		13
	],
	"./052-weather vane.png": [
		49,
		14
	],
	"./100-hay bale.png": [
		50,
		15
	],
	"./111-sexy-farmer.png": [
		51,
		16
	],
	"./112 farm-lady.png": [
		52,
		17
	],
	"./113 PS5.png": [
		53,
		18
	],
	"./114 space monkey.png": [
		54,
		19
	],
	"./115 Pikachu.png": [
		55,
		20
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 17;
module.exports = webpackAsyncContext;